import Vue from 'vue'
import Vuex from 'vuex'
import { store, RootState } from '@/store'

Vue.use(Vuex)

export default new Vuex.Store<RootState>(store)
